export default "__VITE_ASSET__t95isRon__"